import { action, observable } from "mobx";
import type { PageFragment } from "../../app/core/generated/webapi.g";

export interface IPage {
    currentPage: PageFragment | null;
    notFoundPage?: PageFragment;
}

export class Page {
    @observable
    currentPage: PageFragment | null = null;

    @observable
    notFoundPage?: PageFragment;

    @observable
    statusCode? = 200;

    constructor({ currentPage, notFoundPage }: IPage) {
        if (currentPage) {
            this.currentPage = currentPage;
        }

        if (notFoundPage) {
            this.notFoundPage = notFoundPage;
        }
    }

    @action
    storePage = (page: PageFragment | null) => {
        this.currentPage = page;
    };

    @action
    storeStatus = (statusCode: number) => (this.statusCode = statusCode);

    @action
    storeNotFoundPage = (page: PageFragment) => (this.notFoundPage = page);
}
